import {createAction, props} from "@ngrx/store";


export const setActiveClassId = createAction(
  '[Teacher] Set Active Class Id',
  props<{ classId: number }>()
);
